import { AssetListOrderKey } from '../domain';
import { useSetFilter } from '../../filter';

export const useSetAssetListOrder = () => {
  return useSetFilter(AssetListOrderKey, 'assetOrderBy', true);
};
